import type { CSSProperties } from 'react';
import { cn } from '../../../../lib/styles';

// Rounded placeholder bar standing in for text/values in the decorative step graphics; `tone` picks the shade.
const BAR_TONES = {
  /** Primary content, e.g. a product/customer name. */
  default: 'bg-gray-200',
  /** Secondary/supporting content, e.g. sub-labels and detail rows. */
  muted: 'bg-gray-100',
  /** Emphasised content, e.g. a total. */
  strong: 'bg-gray-300',
  /** On a platform-primary surface, e.g. a CTA label. */
  onPrimary: 'bg-white/55',
} as const;

export type BarTone = keyof typeof BAR_TONES;

export function Bar({
  tone = 'default',
  className,
  style,
}: {
  tone?: BarTone;
  className?: string;
  style?: CSSProperties;
}) {
  return <span className={cn('block rounded-full', BAR_TONES[tone], className)} style={style} />;
}
